var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from "vue-property-decorator";
import RegexStr from "../../../common/RegexStr";
var viewImgList = (function (_super) {
    __extends(viewImgList, _super);
    function viewImgList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currIndex = -1;
        _this.dialogVisible = false;
        _this.pdfRegx = new RegExp(RegexStr.pdf);
        return _this;
    }
    viewImgList.prototype.show = function (file) {
        if (!this.data.length) {
            this.$message({
                showClose: true,
                message: this.dataIsEmptyTip,
                type: 'warning'
            });
            return;
        }
        this.currIndex = this.defaultIndex ? this.defaultIndex : 0;
        this.dialogVisible = true;
    };
    __decorate([
        Prop({
            required: true,
            type: Array,
        })
    ], viewImgList.prototype, "data", void 0);
    __decorate([
        Prop({
            type: Number,
            default: 0
        })
    ], viewImgList.prototype, "defaultIndex", void 0);
    __decorate([
        Prop({
            type: String,
            default: 'imageStrArr'
        })
    ], viewImgList.prototype, "dataType", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: true
        })
    ], viewImgList.prototype, "showPage", void 0);
    __decorate([
        Prop({
            type: String,
            default: '没有图片'
        })
    ], viewImgList.prototype, "dataIsEmptyTip", void 0);
    viewImgList = __decorate([
        Component
    ], viewImgList);
    return viewImgList;
}(Vue));
export default viewImgList;
